
import React from 'react';

export const AccountingHeader = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold tracking-tight">Accounting Operations</h1>
      <p className="text-muted-foreground">
        Manage accounting ledgers and post transactions to your Tally ERP system
      </p>
    </div>
  );
};
